var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRosarpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2481 10.7145L12.7939 16.0666L21.1171 10.684L15.6736 30.9937L21.202 30.9983L29.2435 1",
    fill: "#3395FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28967 22.4598L3 30.9981H14.3311L18.9676 13.6289L5.28967 22.4598Z",
    fill: "#072654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRosarpay);
export default __webpack_public_path__ + "static/media/rosarpay.13a1fd3e141b460dea1ba4016db3216d.svg";
export { ForwardRef as ReactComponent };